export default __webpack_public_path__ + "static/brilliantly-warm-banner-1-da1ca235da3be5f030400ca7df6382f6.webp";